import { useState } from "react";
import useTilt3D from "../hooks/useTilt3D";
import ACRateListModal from "./ACRateListModal";
import "./Hero.css";

export default function Hero() {
  const cardRef = useTilt3D(10);
  const [rateListOpen, setRateListOpen] = useState(false);

  return (
    <section className="hero">
      <div className="hero-bg" aria-hidden="true" />
      <div className="container hero-grid">
        <div className="hero-content">
          <span className="hero-badge">Kamra · Attock</span>
          <h1 className="hero-title">
            Professional AC Installation, Repair &amp; Maintenance
          </h1>
          <p className="hero-subtitle">
            Providing Kamra &amp; Attock with reliable, verified and trusted AC Technicians. Book a Verified Technician Now!
          </p>
          <div className="hero-actions">
            <a href="#request-form" className="btn btn-primary">
            Book a Verified Technician
            </a>
            <button
              type="button"
              className="btn hero-rate-btn"
              onClick={() => setRateListOpen(true)}
            >
              <span className="hero-rate-icon" aria-hidden="true"></span>
              View Official Maskanh Rates
            </button>
          </div>
          <div className="hero-stats">
            <div>
              <strong>30 min</strong>
              <span>WhatsApp confirmation</span>
            </div>
            <div>
              <strong>Verified</strong>
              <span>Technicians only</span>
            </div>
            <div>
              <strong>24/7</strong>
              <span>Emergency support</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-card hero-card-3d" ref={cardRef}>
            <div className="hero-card-icon">❄️</div>
            <h3>AC Technician Services</h3>
            <ul>
              <li>Installation &amp; Setup</li>
              <li>Gas Filling &amp; Repair</li>
              <li>Deep Cleaning</li>
              <li>Emergency Support</li>
            </ul>
            <a href="#request-form" className="hero-card-link">
              Request now →
            </a>
          </div>
        </div>
      </div>

      <ACRateListModal
        open={rateListOpen}
        onClose={() => setRateListOpen(false)}
      />
    </section>
  );
}
